module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Mumpf_AG-8c6bc706d4142a819855ce3eb27bfcf3.svg";